import React from 'react';
import { styled } from '@mui/material/styles';
import PropTypes from 'prop-types';
import clsx from 'clsx';
import { Button, TextField, InputAdornment } from '@mui/material';
import SearchIcon from '@mui/icons-material/Search';

import { Link as RouterLink } from 'react-router-dom';

const PREFIX = 'AccountToolbar';

const classes = {
  root: `${PREFIX}-root`,
  row: `${PREFIX}-row`,
  spacer: `${PREFIX}-spacer`,
  searchInput: `${PREFIX}-searchInput`,
};

const Root = styled('div')(({ theme }) => ({
  [`&.${classes.root}`]: {
    marginTop: theme.spacing(3),
    marginBottom: theme.spacing(3),
  },

  [`& .${classes.row}`]: {
    display: 'flex',
    alignItems: 'center',
  },

  [`& .${classes.spacer}`]: {
    flexGrow: 1,
  },

  [`& .${classes.searchInput}`]: {
    flexGrow: 1,
    marginRight: theme.spacing(2),
  },
}));

const AccountToolbar = props => {
  const { className, searchQuery, onSearchChange, ...rest } = props;

  return (
    <Root {...rest} className={clsx(classes.root, className)}>
      <div className={classes.row}>
        <TextField
          className={classes.searchInput}
          placeholder='Поиск по названию или email владельца'
          variant='outlined'
          value={searchQuery || ''}
          onChange={e => onSearchChange && onSearchChange(e.target.value)}
          InputProps={{
            startAdornment: (
              <InputAdornment position='start'>
                <SearchIcon />
              </InputAdornment>
            ),
          }}
        />
        <RouterLink to={'/sa/account/add'}>
          <Button color='primary' variant='contained'>
            Добавить аккаунт
          </Button>
        </RouterLink>
      </div>
    </Root>
  );
};

AccountToolbar.propTypes = {
  className: PropTypes.string,
  searchQuery: PropTypes.string,
  onSearchChange: PropTypes.func,
};

export default AccountToolbar;
